import { ArrowLeftIcon, ArrowRightIcon } from "@heroicons/react/24/solid";
import { useMediaQuery } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { fetchEmployerBeyondJob } from "../../../redux/actions/company_action";
import content_my from "./content_my.json";
import content_sg from "./content_sg.json";
import {
  CardContainer,
  CardImage,
  CardSection,
  CardsWrapper,
  CardText,
  CardTextContainer,
  CarouselContainer,
  GridContainerStyled,
  GridStyled,
  GridTagline,
  NavigationButtons,
  SliderStyled,
  StepButton,
  TaglineContainer,
  TaglineOverline,
  TaglineSubContainer,
  TaglineSubtitle,
  TaglineTitle,
} from "./styles";

export default function EmployHeroBeyondJob() {
  const [beyondJob, setBeyondJob] = useState([]);
  const [beyondJobCard, setBeyondJobCard] = useState([]);

  const containerRef = useRef();
  const [lastScrollTop, setLastScrollTop] = useState(0);
  const [isScrollingDown, setIsScrollingDown] = useState(true);
  const belowLg = useMediaQuery("(max-width: 1023px)");
  const belowTablet = useMediaQuery("(max-width: 767px)");

  const [step, setStep] = useState(0);

  const dispatch = useDispatch();

  async function fetchData() {
    const responseApi = await dispatch(fetchEmployerBeyondJob());

    const isMalaysia = process.env.NEXT_PUBLIC_JSW_GEOLOCATION === "my";
    const response = isMalaysia ? content_my : content_sg;

    const { beyondJob, beyondJobCard } = response || {};

    setBeyondJob(beyondJob);
    setBeyondJobCard(beyondJobCard);
  }

  const handleNextCard = (direction) => {
    if (direction === "left" && step > 0) {
      setStep(step - 1);
    } else if (direction === "right") {
      if (step === beyondJobCard.length - 1) {
        setStep(0);
      } else {
        setStep(step + 1);
      }
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  var belowLgSettings = {
    dots: true,
    infinite: false,
    slidesToShow: 1,
    speed: 500,
    slidesToScroll: 1,
    variableWidth: true,
  };

  if (belowTablet) {
    return (
      <GridContainerStyled id="beyond-content" ref={containerRef}>
        <GridTagline mobile={true}>
          <TaglineContainer>
            <TaglineSubContainer>
              <TaglineOverline>{beyondJob?.overview}</TaglineOverline>
              <TaglineTitle
                dangerouslySetInnerHTML={{ __html: beyondJob?.title }}
              ></TaglineTitle>
            </TaglineSubContainer>
            {beyondJob?.subtitle && (
              <TaglineSubtitle>{beyondJob?.subtitle}</TaglineSubtitle>
            )}
          </TaglineContainer>
        </GridTagline>

        <CarouselContainer>
          <CardsWrapper
            style={{
              transform: `translateX(${-step * 90}vw)`,
            }}
          >
            {beyondJobCard?.map((cards, cardIndex) => (
              <CardContainer key={cardIndex} cardNumber={cardIndex}>
                <CardImage src={cards?.image?.data?.attributes?.url} />
                <CardTextContainer>
                  <CardText type={"title"} cardNumber={cardIndex}>
                    {cards?.title}
                  </CardText>
                  <CardText type={"desc"} cardNumber={cardIndex}>
                    {cards?.description}
                  </CardText>
                </CardTextContainer>
              </CardContainer>
            ))}
          </CardsWrapper>
        </CarouselContainer>

        <div
          style={{
            position: "relative",
            display: "flex",
          }}
        >
          <NavigationButtons>
            <StepButton
              onClick={() => handleNextCard("left")}
              disabled={step === 0 || beyondJobCard.length === 0}
            >
              <ArrowLeftIcon height={24} width={24} color="#FFF" />
            </StepButton>

            <StepButton onClick={() => handleNextCard("right")}>
              {step === 2 ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M4.75541 10.0591C5.82748 6.05814 9.94 3.68377 13.941 4.75584C15.262 5.10979 16.4038 5.79398 17.3036 6.69552L19.2067 8.59859H16.023C15.6088 8.59859 15.273 8.93438 15.273 9.34859C15.273 9.76281 15.6088 10.0986 16.023 10.0986H21.0156C21.2145 10.0986 21.4053 10.0196 21.546 9.87889C21.6866 9.73821 21.7656 9.54742 21.7656 9.34849V4.35599C21.7656 3.94178 21.4298 3.60599 21.0156 3.60599C20.6014 3.60599 20.2656 3.94178 20.2656 4.35599V7.53616L18.3653 5.63586C17.2841 4.55278 15.9116 3.73095 14.3292 3.30695C9.52803 2.02047 4.593 4.86971 3.30653 9.67091C3.19932 10.071 3.43676 10.4823 3.83686 10.5895C4.23696 10.6967 4.64821 10.4592 4.75541 10.0591ZM20.1629 13.4111C19.7628 13.3039 19.3515 13.5413 19.2443 13.9414C18.1722 17.9424 14.0597 20.3168 10.0587 19.2447C8.73774 18.8908 7.59594 18.2066 6.69609 17.3051L4.7942 15.4019H7.97702C8.39123 15.4019 8.72702 15.0661 8.72702 14.6519C8.72702 14.2377 8.39123 13.9019 7.97702 13.9019L2.98438 13.9019C2.57016 13.9019 2.23438 14.2377 2.23438 14.6519V19.6446C2.23438 20.0588 2.57016 20.3946 2.98438 20.3946C3.39859 20.3946 3.73438 20.0588 3.73438 19.6446V16.4634L5.63444 18.3647C6.71564 19.4479 8.08796 20.2696 9.67048 20.6936C14.4717 21.9801 19.4067 19.1308 20.6932 14.3297C20.8004 13.9296 20.563 13.5183 20.1629 13.4111Z"
                    fill="white"
                  />
                </svg>
              ) : (
                <ArrowRightIcon height={24} width={24} color="#FFF" />
              )}
            </StepButton>
          </NavigationButtons>
          <div
            style={{
              height: "56px",
            }}
          ></div>
        </div>
      </GridContainerStyled>
    );
  }

  return (
    <GridStyled>
      <GridContainerStyled>
        <GridTagline>
          <TaglineContainer>
            <TaglineSubContainer>
              <TaglineOverline>{beyondJob?.overview}</TaglineOverline>
              <TaglineTitle
                dangerouslySetInnerHTML={{ __html: beyondJob?.title }}
              ></TaglineTitle>
            </TaglineSubContainer>
            <TaglineSubtitle>{beyondJob?.subtitle}</TaglineSubtitle>
          </TaglineContainer>
        </GridTagline>

        {belowLg && !belowTablet && (
          <SliderStyled {...belowLgSettings}>
            {beyondJobCard?.map((cards) => {
              return (
                <>
                  <CardContainer>
                    <CardImage src={cards?.image?.data?.attributes?.url} />

                    <CardTextContainer>
                      <CardText type={"title"}>{cards?.title}</CardText>
                      <CardText type={"desc"}>{cards?.description}</CardText>
                    </CardTextContainer>
                  </CardContainer>
                </>
              );
            })}
          </SliderStyled>
        )}

        {!belowLg && !belowTablet && (
          <CardSection>
            {beyondJobCard?.map((cards) => {
              return (
                <>
                  <CardContainer>
                    <CardImage src={cards?.image?.data?.attributes?.url} />

                    <CardTextContainer>
                      <CardText type={"title"}>{cards?.title}</CardText>
                      <CardText type={"desc"}>{cards?.description}</CardText>
                    </CardTextContainer>
                  </CardContainer>
                </>
              );
            })}
          </CardSection>
        )}
      </GridContainerStyled>
    </GridStyled>
  );
}
